// Based on this answer
// https://stackoverflow.com/a/45323523
import React, { useState, useEffect, useRef } from 'react';

export default function usePopoverControls<T extends HTMLDivElement>(
  initialVisibility: boolean
): {
  ref: React.RefObject<T>;
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
} {
  const [isVisible, setIsVisible] = useState<boolean>(initialVisibility);

  const ref = useRef<T>(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleClickOutside = ({ target }: { target: any }) => {
    if (ref.current && !ref.current.contains(target)) {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  return { ref, isVisible, setIsVisible };
}
